// Custom Auction Collection JavaScript

class AuctionCollection {
    constructor({ root, templateId, auctionElem }) {
        this.auctionGrid = root;
        this.template = document.getElementById(templateId);
        this.auctionElem = auctionElem;
        this.init();
    }

    init() {
        const auctionData = this.extractAuctionData(this.auctionElem);
        if (auctionData) {
            // Hide all Webkul auction HTML for this product using a CSS class
            const allWkAuctions = document.querySelectorAll('.wk-category-auction[data-prod="' + auctionData.productId + '"]');
            allWkAuctions.forEach(elem => elem.classList.add('swau-hide-wk-auction'));
            const auctionElement = this.createAuctionElement(auctionData);
            this.auctionGrid.appendChild(auctionElement);
        }
    }

    extractAuctionData(auction) {
        if (!auction) return null;
        
        const timerElem = auction.querySelector('[id^="auction_"]');
        const currentBid = this.extractCurrentBid(auction);
        let bidCount = this.extractBidCount(auction);
        let isStartingBid = false;
        let displayBid = currentBid;

        // Get the end date and check if it's in the past
        const endDateStr = this.extractEndDate(auction);
        let isEnded = false;
        if (endDateStr) {
            // Try to parse the end date string
            const parsedDate = new Date(endDateStr);
            if (!isNaN(parsedDate.getTime())) {
                const now = new Date();
                if (parsedDate < now) {
                    isEnded = true;
                }
            }
        }

        // Check for ended_at_div and extract final price if auction is ended
        let endedAtDiv = auction.querySelector('.ended_at_div');
        if (isEnded && endedAtDiv) {
            const finalPriceElem = endedAtDiv.querySelector('.pa-text-color');
            if (finalPriceElem) {
                displayBid = finalPriceElem.textContent.trim().replace(/[^\d.,]/g, '');
            }
        } else {
            // Get the starting bid value from the correct span
            const startBidElem = auction.querySelector('.start_bid_div .pa-text-color');
            let startBidValue = startBidElem ? startBidElem.textContent.trim() : null;
            if (startBidValue) {
                // Extract only the numeric value (e.g., "$ 100" -> "100")
                const match = startBidValue.match(/([\d,.]+)/);
                startBidValue = match ? match[1].replace(/,/g, '') : startBidValue;
            }

            // Treat any zero/empty/"no bid" value as no current bid
            const noBidValues = [
                '', 'No bids', '$', '$0', '$0.00', '$ 0', '$ 0.00', '0', '0.00'
            ];
            const normalizedCurrentBid = (currentBid || '').replace(/\s+/g, '');
            if (noBidValues.includes(normalizedCurrentBid)) {
                if (startBidValue) {
                    displayBid = startBidValue;
                    bidCount = '0';
                    isStartingBid = true;
                } else {
                    displayBid = '0';
                    bidCount = '0';
                    isStartingBid = true;
                }
            } else {
                // Parse current bid to just the number
                const match = currentBid.match(/([\d,.]+)/);
                displayBid = match ? match[1].replace(/,/g, '') : currentBid;
            }
        }

        return {
            id: timerElem ? timerElem.id : '',
            productId: auction.getAttribute('data-prod'),
            customerId: auction.getAttribute('cust-id'),
            currentBid: displayBid,
            bidCount: bidCount,
            endDate: endDateStr,
            timeLeft: isEnded ? '' : this.extractTimeLeft(timerElem),
            isStartingBid: isStartingBid,
            isEnded: isEnded
        };
    }

    extractCurrentBid(auction) {
        const bidElement = auction.querySelector('.wk-current-bid');
        return bidElement ? bidElement.textContent.trim() : '';
    }

    extractBidCount(auction) {
        const countElement = auction.querySelector('.wk-bid-count');
        return countElement ? countElement.textContent.trim() : '0';
    }

    extractEndDate(auction) {
        const dateElement = auction.querySelector('.end_date_div .pa-text-color');
        return dateElement ? dateElement.textContent.trim() : '';
    }

    extractTimeLeft(timerElem) {
        if (!timerElem) return '';
        const timeSpans = timerElem.querySelectorAll('.pa-theme-color');
        if (timeSpans.length !== 4) return '';
        const [days, hours, minutes, seconds] = Array.from(timeSpans).map(span => span.textContent.trim());
        return `${days}:${hours}:${minutes}:${seconds}`;
    }

    createAuctionElement(auction) {
        const clone = this.template.content.cloneNode(true);
        const auctionItem = clone.querySelector('.auction-item');

        // Set auction ID
        auctionItem.setAttribute('data-auction-id', auction.id);

        // Set current bid or starting bid (show only the number)
        const currentBid = clone.querySelector('.current-bid-auction');
        const price = Number(auction.currentBid);
        currentBid.textContent = isNaN(price) ? auction.currentBid : price.toLocaleString();

        // Set bid count
        const bidCount = clone.querySelector('.bid-count-auction');
        bidCount.textContent = auction.bidCount;

        // Set label above bid value
        const bidLabel = clone.querySelector('.auction-main-col-left .label');
        if (auction.isEnded) {
            bidLabel.textContent = 'Final Price';
        } else {
            bidLabel.textContent = auction.isStartingBid ? 'Starting Bid' : 'Current Bid';
        }

        // Add small label under price for ended auctions
        if (auction.isEnded) {
            const priceContainer = clone.querySelector('.current-bid-value');
            const includesBP = document.createElement('div');
            includesBP.textContent = 'Incl buyers premium';
            includesBP.style.fontSize = '11px';
            includesBP.style.color = '#888';
            includesBP.style.marginTop = '-4px';
            includesBP.style.fontWeight = '400';
            includesBP.style.marginBottom = '10px';
            includesBP.style.letterSpacing = '0.5px';
            priceContainer.appendChild(includesBP);
        }

        // Set timer and end date on one line with centered dot
        const timerDisplay = clone.querySelector('.timer-display');
        const endDate = clone.querySelector('.end-date');
        const timerRow = clone.querySelector('.auction-timer-row');
        if (auction.isEnded) {
            timerDisplay.textContent = '';
            // Format the end date string
            let endedDateStr = '';
            if (auction.endDate) {
                const endedDate = new Date(auction.endDate);
                if (!isNaN(endedDate.getTime())) {
                    const options = { year: 'numeric', month: 'long', day: 'numeric' };
                    endedDateStr = endedDate.toLocaleDateString(undefined, options);
                }
            }
            endDate.textContent = endedDateStr ? `Auction Ended ${endedDateStr}` : 'Auction Ended';
            // Center the end-date text
            endDate.style.margin = '0 auto';
            endDate.style.display = 'block';
            endDate.style.textAlign = 'center';
            timerRow.style.justifyContent = 'center';
        } else {
            this.initializeCountdown(timerDisplay, auction.timeLeft);
            endDate.textContent = this.getDayOfWeekOrToday(auction.endDate);
            // Re-introduce dot separator for reliable styling
            if (timerDisplay.textContent) {
                const dot = document.createElement('span');
                dot.className = 'dot-separator';
                dot.textContent = '·';
                timerRow.insertBefore(dot, endDate);
            }
        }

        return auctionItem;
    }

    initializeCountdown(element, timeLeft) {
        if (!timeLeft) return;
        let [days, hours, minutes, seconds] = timeLeft.split(':').map(Number);
        let totalSeconds = days * 86400 + hours * 3600 + minutes * 60 + seconds;
        const timerRow = element.closest('.auction-timer-row');
        
        function formatTime(ts) {
            let d = Math.floor(ts / 86400);
            let h = Math.floor((ts % 86400) / 3600);
            let m = Math.floor((ts % 3600) / 60);
            let s = ts % 60;
            
            // Check if less than 1 hour remaining
            if (d === 0 && h === 0) {
                timerRow.classList.add('less-than-hour');
            } else {
                timerRow.classList.remove('less-than-hour');
            }
            
            if (d > 0) {
                return `Ends in ${d}d ${h}h`;
            } else if (h > 0) {
                return `Ends in ${h}h ${m}m`;
            } else {
                return `Ends in ${m}m ${s}s`;
            }
        }
        
        // Initial check for hiding date
        if (totalSeconds < 21600) {
            timerRow.classList.add('hide-date');
        } else {
            timerRow.classList.remove('hide-date');
        }

        element.textContent = formatTime(totalSeconds);
        const interval = setInterval(() => {
            totalSeconds--;
            if (totalSeconds < 0) {
                timerRow.classList.add('auction-ended');
                timerRow.classList.remove('less-than-hour');
                element.textContent = '';
                clearInterval(interval);
                return;
            }
            // Update hide-date class as timer counts down
            if (totalSeconds < 21600) {
                timerRow.classList.add('hide-date');
            } else {
                timerRow.classList.remove('hide-date');
            }
            element.textContent = formatTime(totalSeconds);
        }, 1000);
    }

    getDayOfWeekOrToday(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        const today = new Date();
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const minutesStr = minutes < 10 ? '0' + minutes : minutes;
        const timeStr = `${hours}:${minutesStr} ${ampm}`;
        if (
            date.getFullYear() === today.getFullYear() &&
            date.getMonth() === today.getMonth() &&
            date.getDate() === today.getDate()
        ) {
            return `Today at ${timeStr}`;
        }
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return `${days[date.getDay()]} at ${timeStr}`;
    }

    handleBidClick(auction) {
        // Implement your bid handling logic here
        console.log('Bid clicked for auction:', auction.id);
        // You can trigger your existing bid modal or implement new bid functionality
    }
}

function renderAuctionWidgetsWhenReady() {
    document.querySelectorAll('.swau-custom-auction-collection:not([data-auction-rendered="true"])').forEach(function(widget) {
        var prodId = widget.getAttribute('data-prod');
        var tryRender = function() {
            var auctionElem = document.querySelector('.wk-category-auction[data-prod="' + prodId + '"]');
            if (
                auctionElem &&
                (
                    auctionElem.querySelector('[id^="auction_"]') ||
                    auctionElem.querySelector('.ended_at_div')
                ) &&
                (
                    auctionElem.querySelector('.wk-current-bid') ||
                    auctionElem.querySelector('.start_bid_div .pa-text-color') ||
                    auctionElem.querySelector('.ended_at_div')
                )
            ) {
                // Always render a new widget for each .swau-custom-auction-collection, even if there are duplicates
                var gridId = `auctionGrid-${prodId}-${Math.random().toString(36).substr(2, 9)}`;
                var templateId = `auctionItemTemplate-${prodId}-${Math.random().toString(36).substr(2, 9)}`;
                widget.innerHTML = `
                    <div class="auction-collection">
                        <div class="auction-grid" id="${gridId}"></div>
                    </div>
                    <template id="${templateId}">
                        <div class="auction-item modern-auction">
                            <div class="auction-main-row">
                                <div class="auction-main-col auction-main-col-left">
                                    <div class="label">Current Bid</div>
                                    <div class="current-bid-value">
                                        <span class="bid-amount-row"><span class="dollar-sign">$</span><span class="current-bid-auction"></span></span>
                                    </div>
                                </div>
                                <div class="auction-main-col auction-main-col-right">
                                    <div class="label">Bids</div>
                                    <div class="bid-count-value"><span class="bid-count-auction"></span></div>
                                </div>
                            </div>
                            <hr class="auction-divider-collection" />
                            <div class="auction-timer-row">
                                <span class="timer-display"></span>
                                <span class="end-date"></span>
                            </div>
                        </div>
                    </template>
                `;
                // Verify template exists before proceeding
                const template = document.getElementById(templateId);
                if (template) {
                    new AuctionCollection({
                        root: widget.querySelector(`#${gridId}`),
                        templateId: templateId,
                        auctionElem: auctionElem
                    });
                    widget.setAttribute('data-auction-rendered', 'true'); // Mark as rendered
                    return true;
                } else {
                    // Template not ready, try again next time
                    return false;
                }
            }
            return false;
        };
        if (!tryRender()) {
            // If not ready, observe for changes
            var observer = new MutationObserver(function() {
                if (tryRender()) observer.disconnect();
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    let timeoutId;
    let observer;
    observer = new MutationObserver((mutations) => {
        // Only proceed if we see new .swau-custom-auction-collection elements
        const hasNewAuctionWidget = Array.from(document.querySelectorAll('.swau-custom-auction-collection:not([data-auction-rendered="true"])')).length > 0;
        if (hasNewAuctionWidget) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                if (window.renderAuctionWidgetsWhenReady) {
                    observer.disconnect();
                    window.renderAuctionWidgetsWhenReady();
                    observer.observe(document.body, { 
                        childList: true, 
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['class', 'data-prod']
                    });
                }
            }, 250);
        }
    });
    observer.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-prod']
    });
});

// ============================================================================
// VAULT COLLECTION FUNCTIONALITY - COMPLETELY SEPARATE FROM AUCTION CODE
// ============================================================================

// Initialize vault collection items
function renderVaultWidgetsWhenReady() {
    document.querySelectorAll('.swau-vault-item-collection:not([data-vault-rendered="true"])').forEach(function(widget) {
        var prodId = widget.getAttribute('data-prod');
        var variantId = widget.getAttribute('data-variant');
        var price = widget.getAttribute('data-price');
        var customerId = widget.getAttribute('data-customer');
        
        var tryRender = function() {
            if (prodId && price) {
                // Create vault item template
                widget.innerHTML = `
                    <div class="swau-vault-collection-details">
                        <div class="swau-vault-collection-price">
                            <div class="swau-vault-collection-label">PRICE</div>
                            <div class="swau-vault-collection-value">${formatVaultPrice(price || '0')}</div>
                        </div>
                    </div>
                    <div class="swau-vault-collection-purchase">
                        <button type="button" class="swau-vault-collection-buy-button" data-variant="${variantId || prodId}">
                            Buy It Now
                        </button>
                        <div class="swau-vault-collection-info">
                            <p>Limited availability from the SWAU Vault</p>
                        </div>
                    </div>
                `;
                
                // Add click handler to buy button
                const buyButton = widget.querySelector('.swau-vault-collection-buy-button');
                if (buyButton) {
                    buyButton.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        console.log('[Vault Collection] Buy button clicked for product:', prodId);
                        
                        // Check if user is logged in
                        if (!customerId) {
                            // User is not logged in, redirect to login page
                            const currentUrl = encodeURIComponent(window.location.href);
                            window.location.href = `https://auction.swau.com/account/login?checkout_url=${currentUrl}`;
                            return;
                        }
                        
                        const variantId = this.getAttribute('data-variant');
                        
                        if (!variantId) {
                            console.error('[Vault Collection] No variant ID found');
                            alert('Product information not available. Please refresh the page and try again.');
                            return;
                        }
                        
                        console.log('[Vault Collection] Attempting to add item to cart with variant ID:', variantId);
                        
                        // Show loading state
                        this.disabled = true;
                        this.textContent = 'Adding to Cart...';
                        
                        // First, check if the item is already in the cart and clear it
                        fetch('/cart.js')
                        .then(response => response.json())
                        .then(cart => {
                            // Check if this variant is already in the cart
                            const existingItem = cart.items.find(item => item.variant_id === parseInt(variantId));
                            
                            if (existingItem) {
                                console.log('[Vault Collection] Item already in cart, clearing cart first');
                                // Clear the entire cart
                                return fetch('/cart/clear.js', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Requested-With': 'XMLHttpRequest'
                                    }
                                });
                            } else {
                                // Item not in cart, proceed directly to add
                                return Promise.resolve();
                            }
                        })
                        .then(() => {
                            // Now add the item to cart
                            return fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-Requested-With': 'XMLHttpRequest'
                                },
                                body: JSON.stringify({
                                    id: parseInt(variantId),
                                    quantity: 1
                                })
                            });
                        })
                        .then(response => {
                            console.log('[Vault Collection] Cart API response status:', response.status);
                            if (!response.ok) {
                                return response.text().then(text => {
                                    console.error('[Vault Collection] Cart API error response:', text);
                                    throw new Error(`Cart API error: ${response.status} - ${text}`);
                                });
                            }
                            return response.json();
                        })
                        .then(data => {
                            console.log('[Vault Collection] Item added to cart successfully:', data);
                            // Redirect to checkout
                            window.location.href = '/checkout';
                        })
                        .catch(error => {
                            console.error('[Vault Collection] Error adding item to cart:', error);
                            // Reset button state
                            this.disabled = false;
                            this.textContent = 'Buy It Now';
                            // Show error message
                            alert('Failed to add item to cart. Please try again or contact support.');
                        });
                    });
                }
                
                widget.setAttribute('data-vault-rendered', 'true'); // Mark as rendered
                return true;
            }
            return false;
        };
        if (!tryRender()) {
            // If not ready, observe for changes
            var observer = new MutationObserver(function() {
                if (tryRender()) observer.disconnect();
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    });
}

// Function to format vault prices with commas (separate from auction formatting)
function formatVaultPrice(price) {
    // Remove any non-numeric characters except decimal point
    const numericPrice = price.toString().replace(/[^\d.]/g, '');
    // Split into dollars and cents
    const [dollars, cents] = numericPrice.split('.');
    // Format dollars with commas
    const formattedDollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Return with $ prefix and cents only if they exist and are not .00
    if (cents && cents !== '00') {
        return `<span class="dollar-sign">$</span>${formattedDollars}.${cents}`;
    } else {
        return `<span class="dollar-sign">$</span>${formattedDollars}`;
    }
}

// Make function available globally (same pattern as auction system)
window.renderVaultWidgetsWhenReady = renderVaultWidgetsWhenReady;



document.addEventListener('DOMContentLoaded', function() {
    let vaultTimeoutId;
    let vaultObserver;
    vaultObserver = new MutationObserver((mutations) => {
        // Only proceed if we see new .swau-vault-item-collection elements
        const hasNewVaultWidget = Array.from(document.querySelectorAll('.swau-vault-item-collection:not([data-vault-rendered="true"])')).length > 0;
        if (hasNewVaultWidget) {
            if (vaultTimeoutId) {
                clearTimeout(vaultTimeoutId);
            }
            vaultTimeoutId = setTimeout(() => {
                if (window.renderVaultWidgetsWhenReady) {
                    vaultObserver.disconnect();
                    window.renderVaultWidgetsWhenReady();
                    vaultObserver.observe(document.body, { 
                        childList: true, 
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['class', 'data-prod']
                    });
                }
            }, 250);
        }
    });
    vaultObserver.observe(document.body, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-prod']
    });
});

 